import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { env } from '../../Env.js';
import { isURL, joinPath } from '../../utils/url.js';
export function renderContentPageHead(data) {
    const { title, main, og, twitter, jsonLd } = data;
    const { description, keywords, canonical, robots } = main || {};
    return [
        _jsx("title", { children: title }, "title"),
        _jsx("meta", { name: "viewport", content: "width=device-width, initial-scale=1" }, "viewport"),
        description ? _jsx("meta", { name: "description", content: description }, "description") : null,
        keywords ? _jsx("meta", { name: "keywords", content: keywords.join(',') }, "keywords") : null,
        robots ? _jsx("meta", { name: "robots", content: robots.join(',') }, "robots") : null,
        renderOpenGraph(og),
        renderTwitter(twitter),
        canonical ? _jsx("link", { rel: "canonical", href: applyAbsoluteHref(canonical) }, "canonical") : null,
        jsonLd ? (_jsx("script", { type: "application/ld+json", children: jsonLd }, "jsonLd")) : null,
    ].filter(Boolean);
}
function renderOpenGraph(og) {
    return og
        ? Object.entries(og).map(([key, value]) => (_jsx("meta", { property: `og:${key}`, content: key === 'url' ? applyAbsoluteHref(value) : value }, `og_${key}`)))
        : null;
}
function renderTwitter(twitter) {
    return twitter
        ? Object.entries(twitter).map(([key, value]) => (_jsx("meta", { name: `twitter:${key}`, content: value }, `twitter_${key}`)))
        : null;
}
function applyAbsoluteHref(href) {
    return env.SITE_URL && href && !isURL(href) ? joinPath(env.SITE_URL, href) : href;
}
//# sourceMappingURL=renderContentPageHead.js.map